import type { ClientMenuItem } from '@dealerportal/common';
import { useContext } from 'react';
import { NavigationContext } from './Navigation';
import NavMobileDropDown from './NavMobileDropDown';

type Props = {
  menu: ClientMenuItem;
  depthLevel: number;
};

export default function NavMobileMenuItems(props: Props) {
  const navClassNames = useContext(NavigationContext);

  return (
    <ul
      className={`nav__grandchild-list !ui-m-0 !ui-p-0 !ui-list-none ${navClassNames.grandchildlistclass}`}
    >
      {props.menu.children?.map((child, index) => (
        <NavMobileDropDown
          key={`${child.alias}-${index}`}
          menu={child}
          depthLevel={props.depthLevel}
          onClickHandler={() => {}}
        />
      ))}
    </ul>
  );
}
